import Phaser from 'phaser'
import Platform from '../actors/platform'
import Obstacle from '../actors/obstacle'
import BreakablePlatform from '../actors/breakablePlatform'
import Cake from '../actors/cake'
import Guide from '../actors/guide'
import RepeatingPlatformManager from '/actors/repeatingPlatformManager'
import RepeatingObstacleManager from '/actors/repeatingObstacleManager'
import LevelGenerator from '/components/levelGenerator'

export default class Spawner {
  constructor (scene) {
    this.scene = scene
    this.player = scene.player
    this.finishX = 100000
    this.lowestPlatformY = -100000

    this.objects = []
    // this.platforms = []
    this.spawnId = 1

    this.guide = null

    this.dict = {
      sPl: Platform,
      gui: Guide,
      obs: Obstacle,
      bPl: BreakablePlatform,
      rPl: RepeatingPlatformManager,
      rObs: RepeatingObstacleManager,
      cake: Cake
    }
  }

  findObjectById (id) {
    for (var i = 0; i < this.objects.length; i++) {
      if (this.objects[i].id === id) {
        return this.objects[i]
      }
    }
  }

  spawnRatedLevel (nRespawns) {
    this.nRespawns = nRespawns

    var gen = new LevelGenerator(this.scene)
    var seed = '' + (this.scene.levelId * 7919)
    gen.newGenerateLevel(seed, this.scene.difficultyManager.getRating())

    // this.level = new Level()
    // this.nextObjectDef = -1
    // this.nRespawns = nRespawns

    // var levelGen = new LevelGenerator(this.scene, this.player)
    // var seed = '' + (this.scene.levelId * 7919)
    // levelGen.generateLevelWithRating(this.scene.difficultyManager.getRating(), seed)

    // this.spawnPostFinishObjects()
  }

  spawnLevelFromDef (level) {
    var nextObjectDef = level.getNextObjectDef()

    while (nextObjectDef !== -1) {
      this.spawnFromDef(nextObjectDef)
      nextObjectDef = level.getNextObjectDef()
    }

    // now that all objects have spawned, attach children to their parents
    for (var i = 0; i < this.objects.length; i++) {
      if (this.objects[i].parentId >= 0) {
        this.objects[i].attachTo(this.findObjectById(this.objects[i].parentId), this.objects[i].parentOffsetX, this.objects[i].parentOffsetY)
      }
    }
  }

  spawnLevelFromJSON (json, nRespawns) {
    this.nRespawns = nRespawns
    var level = this.scene.levelDefs.createFromJSONString(json)
    this.spawnLevelFromDef(level)
  }

  spawnFromDef (def, editable = false, doSave = true) {
    if (def.data.id) {
      // this.spawnId = def.data.id + 1
    } else {
      def.data.id = this.spawnId
    }
    this.spawnId = def.data.id + 1

    var obj = new this.dict[def.type](this.scene, def.data, doSave)
    this.scene.add.existing(obj)
    this.objects.push(obj)

    if (editable) {
      obj.showEditing()
    }

    if (obj instanceof Platform) {
      // TODO: this only works if we dont move platforms around in the editor..
      // this.platforms.push(obj)
      // this.platforms.sort((objA, objB) => { return objA.image.x - objB.image.x })
      // for (var i = 0; i < this.platforms.length - 1; i++) {
      // this.platforms[i].nextPlatform = this.platforms[i + 1]
      // }
      this.lowestPlatformY = Math.max(this.lowestPlatformY, def.data.y - (def.data.height / 2))
      this.scene.player.gameoverThreshold = this.lowestPlatformY + 500
    } else if (obj instanceof Guide) {
      this.guide = obj
      this.onSpawnGuide()
    }

    return obj
  }

  clearLevel () {
    for (var i = 0; i < this.objects.length; i++) {
      this.objects[i].delete()
    }
    this.objects = []
    // this.platforms = []
    if (this.guide) {
      this.guide.delete()
    }
  }

  addGuidePoint (x, y) {
    if (this.guide) {
      this.guide.insertPoint(x, y)
      this.guide.showEditing()
    }
  }

  addGuideStart (x, y, hopSize = 500, showEditing = false) {
    // debugger
    if (!this.guide) {
      var def = { type: 'gui', data: { nPoints: 2, p0: { x: x, y: y, start: true }, p1: { x: x + hopSize, y: y } } }
      this.spawnFromDef(def)
    } else {
      this.guide.addStart(x, y)
    }
    if (showEditing) {
      this.guide.showEditing()
    }
  }

  setLevelEmpty () {
    var def = { type: 'sPl', data: { x: 0, y: 700, width: 2200, height: 600 } }
    this.spawnFromDef(def)

    if (this.guide) {
      this.guide.delete()
    }

    // def = { type: 'gui', data: { nPoints: 2, p0: { x: 400, y: 410, start: true }, p1: { x: 1000, y: 410 } } }
    // this.spawnFromDef(def)
  }

  setLevel (level, nRespawns) {
    this.spawnLevelFromDef(level)
  }

  onDelete (obj) {
    var index = this.objects.indexOf(obj)
    if (obj && index > -1) {
      this.objects.splice(index, 1)
    }

    if (obj instanceof Platform) {
      // var index = this.platforms.indexOf(obj)
      // if (obj && index > -1) {
      //   this.platforms.splice(index, 1)
      // }
      // this.platforms.sort((objA, objB) => { return objA.image.x - objB.image.x })
      // for (var i = 0; i < this.platforms.length - 1; i++) {
      //   this.platforms[i].nextPlatform = this.platforms[i + 1]
      // }
    }
  }

  convertGuideToTexture () {
    var maxTextureSize = 1024
    try {
      maxTextureSize = this.scene.game.renderer.getMaxTextureSize()
    } catch (e) {
      // ...
    }

    var textureSize = this.guide.editor.points[this.guide.editor.points.length - 1].x + 100
    if (textureSize > maxTextureSize) {
      for (var i = 0; i < Math.ceil(textureSize / maxTextureSize); i++) {
        this.guide.graphics.generateTexture('guide-' + i + '-' + this.scene.levelId, maxTextureSize, maxTextureSize)
        this.scene.add.image(i * maxTextureSize, 0, 'guide-' + i + '-' + this.scene.levelId).setOrigin(0, 0).setAlpha(0.5)
        this.guide.refresh((i + 1) * maxTextureSize)
      }
    } else {
      this.guide.graphics.generateTexture('guide' + this.scene.levelId, textureSize, textureSize)
      this.scene.add.image(0, 0, 'guide' + this.scene.levelId).setOrigin(0, 0).setAlpha(0.5)

      // this.guide.graphics.generateTexture('guide', textureSize, textureSize)
      // this.scene.add.image(0, 0, 'guide').setOrigin(0, 0).setAlpha(0.5)
    }
    this.guide.graphics.destroy()
  }

  onSpawnGuide () {
    // hide guide if player is further than level 5 and hasnt respawned much yet:
    if (this.scene.levelId > 5 && this.nRespawns < Math.ceil(this.scene.difficultyManager.getRating() / 500)) {
      this.guide.graphics.destroy()
    }
  }

  spawnPhysicsObject (x, y, black, prev) {
    return null
  }

  isGapAt (x, leniency) {
    return -1
  }

  getBounceDirAtGap (i, x, playerWidth) {
    return 0
  }

  pauseMovers () {
    for (var i = 0; i < this.objects.length; i++) {
      if (this.objects[i].moveComponent) {
        this.objects[i].moveComponent.pause()
      }
    }
  }

  unPauseMovers () {
  }
}
